import { defineComponent, h, watch, ref } from 'vue';
import { col, cols, loader, pageTitle } from '@/ui/components';
import { searchFilter, templateCategoryFilter } from '@/ui/components/filters';
import { useTask } from '@/ui/concerns';
import { list as getTemplateCategories } from '@/services/api/resources/template/category/actions';
import { list as getTemplates } from '@/services/api/resources/template/actions';
import { templateCategory, templates } from '@/ui/auth/templates';
import * as qs from '@/ui/queryState';
import { Icon } from '@/ui/components/icon/Icon';
import { t } from '@/ui/i18n/i18n';
import { useInfiniteScroll } from '@/ui/pages/useInfiniteScroll';

export const Filters = defineComponent({
  name: 'Filters',
  setup(_, ctx) {
    const totalPages = ref(1);
    const currentPage = ref(1);
    const name = qs.string('search', '');
    const industry = qs.string('industry', '');
    const getInitialFilters = useTask(
      () => getTemplateCategories(),
      templateCategories => {
        templateCategory.value = templateCategories.data;
      },
    );
    const getTemplatesTask = useTask(
      () => getTemplates({ search: name.value, category: industry.value, page: currentPage.value.toString() }),
      templatesResponse => {
        ctx.emit('fetching:templates', false);
        templates.value = [...templates.value, ...templatesResponse.data];
        currentPage.value = templatesResponse.meta.current_page;
        totalPages.value = templatesResponse.meta.last_page;
      },
    );

    const { onFilterChange } = useInfiniteScroll({
      bottomOffset: 400,
      containerSelector: 'window',
      task: getTemplatesTask,
      resources: templates,
      totalPages,
      currentPage,
    });

    watch([name, industry], () => {
      ctx.emit('fetching:templates', true);
      onFilterChange();
      getTemplatesTask.run();
    });

    getTemplatesTask.run();
    getInitialFilters.run();

    return function render() {
      return loader('div', getTemplatesTask, [
        h('div', { class: 'checklist-templates__filters' }, [
          pageTitle(t('checklist-templates.or-choose-templates')),
          cols([
            col([
              searchFilter(name, () => {}, 'search', true, t('common.search')),
            ], true, { 'is-3': true }),
            col([
              h('span', { class: 'checklist-templates__industry-label' }, [
                h(Icon, { props: { icon: 'building' } }),
                `${t('common.industry')}:`,
              ]),
              templateCategoryFilter(industry, () => {}, t('form.all-industries')),
            ], true, { 'checklist-templates__industry-label-column': true }),
          ]),
        ]),
      ]);
    };
  },
});
